import { render, staticRenderFns } from "./Similar.vue?vue&type=template&id=13ea8941&scoped=true"
import script from "./Similar.vue?vue&type=script&lang=js"
export * from "./Similar.vue?vue&type=script&lang=js"
import style0 from "./Similar.vue?vue&type=style&index=0&id=13ea8941&prod&lang=scss&scoped=true"
import style1 from "./Similar.vue?vue&type=style&index=1&id=13ea8941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea8941",
  null
  
)

export default component.exports